<template>
  <div class="activity-page">
    <img class="activity-image" :src="activity" alt="">
  </div>
</template>

<script>
import activity from '@/assets/img/activity/activity.jpg'
export default {
  name: 'Activity',
  data() {
    return {
      activity
    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.activity-page {
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 100vh;
  // background-color: #D82A23;
  .activity-image {
    width: 40%;
    max-width: 100%;
  }
}
</style>